export enum CRITICAL_INFO_TYPE {
  resuscitation = 'resuscitation',
  intubation = 'intubation',
  organDonation = 'organDonation',
  geneticTesting = 'geneticTesting',
}
